<header>

<div class="h-stack">
  <div>THE</div>
  <div>mewithoutYou</div>
  <div>“FAREWELL”</div>
  <div>TOUR <span>[visualized]</span></div>
</div>

<div class="byline">A data visualization by <a href="https://www.jaredwhalen.com/" target="_blank">Jared Whalen</a></div>

  <div class="g-share">
    <a target="_blank" href="https://twitter.com/jared_whalen">
      <svg id="twitter" data-name="twitter" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 509.42 416">
        <g id="tfnVb0.tif">
          <path
            d="M-3.11,410.8c56,5,106.56-8.77,152.36-43.23-47.89-4.13-79.86-28.14-97.63-73.21,16,2.44,30.77,2.3,46.51-1.91-24.84-6.09-44.73-18.21-60-37.41S15.32,213.9,15.38,188.45c14.65,7.48,29.37,12.07,46.68,12.78-22.82-16.77-37.49-37.61-43.29-64.17C13,110.68,17,85.73,30.31,61.75q85.13,100,214.85,109.34c-.33-11.08-1.75-21.73-.76-32.15,4-42.5,26-73.13,65.46-88.78,41.28-16.37,79.22-8,112,22.16,2.48,2.28,4.55,2.9,7.83,2.12,19.82-4.68,38.77-11.52,56.54-21.53,1.43-.8,2.92-1.5,5.38-2.76-8.05,24.47-22.71,42.58-42.92,57.38,6.13-1.11,12.31-2,18.36-3.37,6.46-1.5,12.85-3.33,19.16-5.34,6.1-1.95,12.07-4.32,19.55-7-4.48,6-7.57,11.41-11.78,15.66-11.9,12-24.14,23.72-36.54,35.23-2.56,2.38-3.77,4.42-3.69,7.93,1.32,62.37-15.12,119.9-48.67,172.3C361.52,391,300.21,434.46,220.88,451,155.93,464.6,92.65,458.29,32,430.75c-12.17-5.52-23.75-12.33-35.6-18.55Z"
            transform="translate(3.64 -41.93)"></path>
        </g>
      </svg>
    </a>
    <a target="_blank" href="https://github.com/jaredwhalen/mwy-farewell-tracker">
      <svg id="github" data-name="github" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.58 31.77">
        <path
          d="M249.88,233.65a16.29,16.29,0,0,0-5.15,31.75c.81.15,1.11-.35,1.11-.78s0-1.41,0-2.77c-4.53,1-5.49-2.19-5.49-2.19a4.3,4.3,0,0,0-1.81-2.38c-1.48-1,.11-1,.11-1a3.41,3.41,0,0,1,2.5,1.68,3.46,3.46,0,0,0,4.74,1.35,3.54,3.54,0,0,1,1-2.18c-3.61-.41-7.42-1.8-7.42-8a6.3,6.3,0,0,1,1.68-4.37,5.82,5.82,0,0,1,.16-4.31s1.37-.44,4.48,1.67a15.41,15.41,0,0,1,8.16,0c3.11-2.11,4.47-1.67,4.47-1.67a5.82,5.82,0,0,1,.16,4.31,6.26,6.26,0,0,1,1.68,4.37c0,6.26-3.81,7.64-7.44,8a3.91,3.91,0,0,1,1.11,3c0,2.18,0,3.93,0,4.47s.29.94,1.12.78a16.3,16.3,0,0,0-5.16-31.75Z"
          transform="translate(-233.59 -233.65)" style="fill-rule:evenodd"></path>
      </svg>
    </a>
  </div>
</header>


<style lang="scss">

  header {
    margin-top: 100px;
    text-align: center;
    width: 100vw;
    overflow: hidden;
  }

   header .g-share {
     display: flex;
     justify-content: center;
     align-items: center;
     padding: 15px 0px;
  }

  header .g-share svg {
    width: 20px;
    margin: 0px 10px;
    opacity: 1;
    fill: var(--color-offwhite);
  }


  .h-stack {
    // font-size: 16px;
    font-size: 2vw;
    font-family: 'Amiri', serif;

    div {
      padding-bottom: 15px;
      &:nth-child(1) {
        @include font-clamp(12px, 18px);
        line-height: 1;
      }
      &:nth-child(2) {
        @include font-clamp(20px, 30px);
        font-style: italic;
        font-family: var(--font-mwy);
        line-height: 1;
      }
      &:nth-child(3) {
        @include font-clamp(20px, 70px);
        font-weight: bold;
        line-height: 0.8;
        color: var(--color-offwhite);
      }
      &:nth-child(4), &:nth-child(5) {
        @include font-clamp(12px, 18px);
        line-height: 0.8;
      }

      span {
        font-family: var(--font-mwy);
        font-style: italic;
        color: var(--color-offwhite)
      }

    }
  }

  .byline {
    font-family: var(--font-sans);
    color: var(--color-offwhite);
    font-size: 18px;
    padding: 15px 0px 0px;
    a {
      color: var(--accent);
      text-decoration: none;
    }
  }



</style>
